module.exports = __webpack_public_path__ + "static/cfg-3-1d6c387c893063fbcb0fdb933d2a4859.jpeg";